<template>
  <div class="region-select">
    <div
      class="info-control region"
      v-if="allArea.length == 1"
      style="margin-top: 0.05rem"
      @click="showPanel"
    >
      <span v-if="allArea.length == 1">请选择区域、卫生服务中心、签约团队</span>
    </div>
    <div
      class="info-control region"
      v-else
      style="margin-top: 0.05rem"
      @click="showPanel"
    >
      <span class="choosed" v-for="(item, index) in allArea"
        >{{ getStr(item) }}
        <span v-if="index < allArea.length - 1">&gt</span></span
      >
    </div>
    <div class="region-panel" v-if="isShow">
      <div class="region-city">
        <div class="areaList">
          已选:<span class="choosed" v-for="(item, index) in allArea"
            >{{ item }}<span v-if="index < allArea.length - 1">&gt;</span></span
          >
        </div>
      </div>
      <div
        class="region-list"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isDisabled"
        infinite-scroll-distance="10"
        infinite-scroll-throttle-delay="2000"
      >
        <div
          class="info-control region"
          v-for="(item, index) in region"
          style="margin-top: 0.05rem"
          @click="selectArea(index)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regionService from 'region.service'
import infiniteScroll from 'vue-infinite-scroll'
export default {
  data () {
    return {
      region: [],
      allArea: ['彭州市'],
      selectAreaIndex: 0,
      isShow: false,
      page: 1,
      rows: 15,
      id: '',
      pid: '510182',
      busy: false,
      end: false,
    }
  },
  directives: {
    infiniteScroll
  },
  computed: {
    isDisabled () {
      return this.busy
    }
  },
  mounted () {
    window.onpopstate = () => {
      if (this.isShow) {
        this.isShow = false
        this.id = ''
        this.$emit('doctorGroup', this.id)
        history.go(1)
      }
    }
  },
  methods: {
    loadArea (index) {
      this.busy = true
      regionService.loadArea({
        page: this.page,
        rows: this.rows,
        pid: this.pid
      }).then((res) => {
        this.busy = false
        // 返回结果失败
        if (res.stateCode !== 200) {
          // 非查询不到数据
          if (res.stateCode !== 203) {
            this.$utils.alert(res.resultMsg);
          } else {
            if (index !== undefined && this.page == 1) {
              this.id = this.region[index].id
              this.loadDoctorTeam(index)
            }
          }
          return
        }
        // 当page为1时，为拉取新一级的数据，需要清空原先的数组
        if (this.page == 1) {
          if (index !== undefined) {
            this.allArea.push(this.region[index].name)
          }
          this.region = []
        }
        this.region = this.region.concat(res.data.rows)
      })
    },
    loadDoctorTeam (index) {
      this.busy = true
      regionService.loadDoctorTeam({
        page: this.page,
        rows: this.rows,
        'address.id': this.id
      }).then((res) => {
        this.busy = false
        if (res.stateCode !== 200) {
          if (res.stateCode !== 203) {
            this.$utils.alert(res.resultMsg);
          }
          return
        }
        if (this.page == 1) {
          this.allArea.push(this.region[index].name)
          this.region = []
        }
        this.end = true
        this.region = this.region.concat(res.data.rows)
      })
    },
    showPanel () {
      this.region = []
      this.page = 1
      this.allArea = ['彭州市']
      this.id = '',
        this.pid = '510182',
        this.busy = false,
        this.end = false,
        this.isShow = true
      this.loadArea()
    },
    selectArea (index) {
      if (this.busy) {
        return
      }
      this.id = this.region[index].id
      this.page = 1
      this.pid = this.region[index].codeValue
      if (this.end) {
        this.allArea.push(this.region[index].name)
        this.$emit('doctorGroup', this.id)
        this.isShow = false
        return
      } else {
        // 加载区域
        this.loadArea(index)
      }
    },
    loadMore () {
      this.page += 1
      this.loadArea()
    },
    getStr (str) {
      if (str.length > 4) {
        return str.substr(0, 4) + '...'
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.region-select {
  .region-city {
    height: 1rem;
    line-height: 1rem;
    padding-left: 0.5rem;
    background-color: #51a8ed;
    color: #fff;
    .areaList {
      display: flex;
    }
  }
  .info-control {
    position: relative;
    height: 2.25rem;
    line-height: 2.25rem;
    background-color: #fff;
    padding-left: 0.25rem;
    border-bottom: 0.075rem solid #eef2f5;
    &.region {
      position: relative;
      padding-left: 0.75rem;
    }
    &.region:before {
      position: absolute;
      content: "";
      width: 0.425rem;
      height: 0.675rem;
      top: 50%;
      right: 0.875rem;
      margin-top: -0.335rem;
      background: url(../../static/img/more-arrow.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}

.region-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all 0.6s;
  background-color: #fff;
  overflow: hidden;
  z-index: 9999;

  .region-list {
    position: absolute;
    top: 2rem;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;

    .isloading {
      height: 2rem;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// RegionSelect.vue?373f91c3